import DOMPurify, {type Config} from 'dompurify';

/**
 * Sanitizes tenant-authored HTML destined for `v-html`.
 *
 * Storefronts render HTML written by tenants (listing descriptions, extra options,
 * website-builder section text). That content is untrusted: a tenant is not an
 * attacker by default, but multi-tenancy means never relying on that. Storefronts
 * also currently share a registrable domain with the backoffice, so script running
 * there is same-site with admin sessions.
 *
 * Every `v-html` binding fed by tenant data must pass through here. Prefer calling
 * it at the data source (composable/getter) rather than per template, so new call
 * sites are safe by default.
 *
 * `options` extends DOMPurify's defaults for a specific surface (e.g. allowing
 * `target` on links); never use it to re-allow scripts or event handlers.
 */
export function sanitizeHtml(html: string | null | undefined, options: Config = {}): string {
    if (!html) {
        return '';
    }

    return DOMPurify.sanitize(html, options) as string;
}
